module.exports = __webpack_public_path__ + "img/logo_beritasatu.90b0c46e.png";